import React from "react"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  customstyle: {
    width: "100%",
    boxSizing: "border-box",
    fontFamily: '"Roboto", sans-serif !important',
    backgroundColor: '#fff',
  },
  smallOutlinedInput: {
    fontSize: "12px",
    padding: "5px 6px 6px 6px",
    resize: "vertical",
    border: "1px solid #ccc",
    borderRadius: "4px",
    outline: "none",
    transition: "all 0.2s ease",

    "&:focus": {
      borderColor: "#0288d1",
    },
    "&:disabled": {
      color: "#5F6071",
    },

    /* ====================
       Responsive tweaks
    ==================== */
    [theme.breakpoints.down('lg')]: { // ≤1279px
      fontSize: "11.5px",
      padding: "5px",
      borderRadius: "4px",
    },
    [theme.breakpoints.down('md')]: { // ≤959px
      fontSize: "11px",
      padding: "4px",
      borderRadius: "3px",
    },
    [theme.breakpoints.down('sm')]: { // ≤599px
      fontSize: "10.5px",
      padding: "3px 4px",
      borderRadius: "3px",
    },
    [theme.breakpoints.down('xs')]: { // ≤400px
      fontSize: "10px",
      padding: "2px 3px",
      borderRadius: "2px",
    },
  },
  smallNotchedOutline: {
    fontSize: "12px",
    borderColor: "#ccc",
    [theme.breakpoints.down('sm')]: { fontSize: "11px" },
    [theme.breakpoints.down('xs')]: { fontSize: "10.5px" },
  },
}));

const CustomTextAreaField = (props) => {
  const { element, dataObj, onChange } = props
  const customclasses = useStyles();

  return (
    <div>
      <textarea
        className={`${customclasses.customstyle} ${customclasses.smallOutlinedInput}`}
        key={element.value || element.name}
        rows={7} // you can adjust dynamically if you want (see below)
        disabled={element.readOnly}
        value={dataObj[element.value] || dataObj[element.name]}
        name={element.value || element.name}
        onChange={(e) => {
          onChange((element.value || element.name), e.target.value, element.type)
        }}
      />
    </div>
  )
}

export default CustomTextAreaField
